import * as Yup from 'yup';

const FirstStepSchemaValidator = () => Yup.object().shape({
  benefitEstimator: Yup.object().shape({
    filingStatus: Yup.string().required('This field is required'),
  }),
});

export default FirstStepSchemaValidator;
